/* eslint-disable no-fallthrough */
import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';

import {
  Agencies,
  ICalendarEventType,
  PharmacistLegendVariant,
  PharmacyLegendVariant,
} from '@pharmaplan/common';

import useSelfService from '../../../hooks/useSelfService';
import strings from '../../../localization';

import styles from './styles';

interface IPostedByAgencyTag {
  customStyle?: SxProps;
  type?: ICalendarEventType;
}

const logoFile = '/logo192.png';
const { workshift, requested, booked } = PharmacistLegendVariant;
const { posted } = PharmacyLegendVariant;

const handledTypes = new Set([workshift, requested, booked, posted]);

const PostedbyAgencyTag: FC<IPostedByAgencyTag> = ({ customStyle, type }) => {
  const { isSelfService } = useSelfService();
  const agency = isSelfService ? Agencies.PharmaPlan : Agencies.PharmaGap;

  const agencyInfo = {
    [Agencies.PharmaPlan]: {
      logo: `${process.env?.REACT_APP_SYNC_URL}${logoFile}`,
      agencyName: 'PharmaPlan',
    },
    [Agencies.PharmaGap]: {
      logo: `${process.env?.REACT_APP_SYNC_URL}${logoFile}`,
      agencyName: 'PharmaGap',
    },
  };

  const { logo, agencyName } = agencyInfo[agency];

  const typeConfig = () => {
    if (!type || !handledTypes.has(type as PharmacyLegendVariant)) {
      return {
        label: strings.formatString(strings.postedByFormat, agencyName),
        tagStyle: styles.workshift,
      };
    }

    const config = {
      [workshift]: {
        label: strings.formatString(strings.postedByFormat, agencyName),
        tagStyle: styles.workshift,
      },
      [requested]: {
        label: strings.formatString(
          isSelfService ? strings.postedByFormat : strings.requestedByFormat,
          agencyName,
        ),
        tagStyle: styles.requested,
      },
      [booked]: {
        label: strings.formatString(strings.bookedWithFormat, agencyName),
        tagStyle: styles.booked,
      },
      [posted]: {
        label: strings.formatString(strings.postedByFormat, agencyName),
        tagStyle: styles.workshift,
      },
    };

    return config[type as keyof typeof config];
  };

  const { label } = typeConfig();

  return (
    <Box sx={[styles.container, customStyle] as SxProps}>
      <Box sx={[styles.tagContainer]}>
        <img src={logo} alt={strings.bannerLogo} style={styles.logo} />
        <Typography sx={styles.tag}>{label}</Typography>
      </Box>
    </Box>
  );
};

export default PostedbyAgencyTag;
